<script>
import Layout from '@layouts/main'
import CouponForm from './CouponForm'

export default {
  page: {
    title: '新增優惠券',
    meta: [{ name: 'description', content: 'Add Coupon' }],
  },
  components: { Layout, CouponForm, BaseSteps: () => import('@components/BaseSteps'), Step1: () => import('./CouponForm'), Step2: () => import('./CouponTarget') },
  data() {
    return {
      activeStep: 1,
      stepList: Object.freeze([
        {
          title: '基本資訊',
          description: '請填寫下方欄位',
          // component: () => import('./components/Step1Basic'),
        },
        {
          title: '設定適用對象',
          description: '請選取可抵扣的購買方案',
          // component: () => import('./components/Step2Prices'),
        },
      ]),
      tryingNextStep: false,
      nextStepButtonVisible: false,
      step1Data: undefined,

      defaultValue: {},
    }
  },
  methods: {
    backToList() {
      this.$router.push({ name: 'coupon' })
    },
    async onClickNextStep(currentStep) {
      this.tryingNextStep = true
      try {
        
        switch (currentStep) {
          case 1:
            await this.$refs.step.validate()
            // await this.$refs.step.tryToStore()
            this.step1Data = this.$refs.step.submitData

            this.activeStep++
            this.tryingNextStep = false
            break

          case 2:
            try {
              console.log(this.$refs.step.filterSubmitData)
              await this.$store.dispatch('coupon/store', this.$refs.step.filterSubmitData)
              this.$message({
                message: `創建成功！`,
                type: 'success',
              })
              this.$router.push({ name: 'coupon' })
            } catch (error) {}
            this.tryingNextStep = false
            break
        }
      } catch (error) {
        this.tryingNextStep = false
      }
    },
    onClickLeave() {
      this.$confirm('尚未完成新增，請問是否確定離開新增優惠券？', '您將離開此頁面', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        showClose: false,
      }).then(() => {
        this.$router.push({ name: 'coupon' })
      })
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageHeader title="新增優惠券">
      <BaseSteps slot="center" :active="activeStep" :list="stepList" />
    </BasePageHeader>
    <el-card>
      <keep-alive>
        <component :is="`step-${activeStep}`" ref="step" :default-value="step1Data" @back="backToList"></component>
      </keep-alive>
      <div :class="$style.footer">
        <el-button class="is-round" data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。" @click="onClickLeave">離開</el-button>
        <el-button class="is-round" data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步" type="primary" :loading="tryingNextStep" @click="onClickNextStep(activeStep)">{{
          activeStep === 1 ? '下一步' : '建立優惠券'
        }}</el-button>
      </div>
    </el-card>
  </Layout>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
